import React from 'react'

const backends = {
  fi: {
    v2: 'https://app.birdietime.com/modules/custom/btapi/v2/',
  },
  en: {
    v2: 'https://admin.birdietime.com/modules/custom/btapi/v2/',
  },
}

const withBackend = (Comp) => {
  const Container = ({ locale = 'en', version = 'v2', ...rest }) => (
    <Comp backend={backends[locale][version]} locale={locale} version={version} {...rest} />
  )
  return Container
}

export default withBackend



// WEBPACK FOOTER //
// ./src/utils/withBackend.js